<template>
  <footer class="footerS">
    <a href="/" class="brand">
      <img :src="dueLogoUrl" alt="DUE logo" class="logoHome" />
      <span class="copy">Copyright {{ currentYear }} - Todos os direitos reservados<span v-if="appVersion"> | <button type="button" class="version-link" @click.stop.prevent="openReleaseNotes">Versão {{ appVersion }}<span v-if="buildVersion"> (build {{ buildVersion }})</span></button></span></span>
    </a>
    <div v-if="showReleaseNotes" class="modal-overlay" @click="closeReleaseNotes">
      <div class="modal-content" @click.stop>
        <button class="icon-button modal-close" type="button" @click="closeReleaseNotes" title="Fechar" aria-label="Fechar">
          <i class="fas fa-times"></i>
        </button>
        <h2>Resumo da versão {{ appVersion }}</h2>
        <p v-if="buildVersion" class="build-text">Build {{ buildVersion }}</p>
        <ul v-if="releaseNotes.length">
          <li v-for="(note, idx) in releaseNotes" :key="idx">{{ note }}</li>
        </ul>
        <p v-else class="empty-text">Nenhuma atualização registrada.</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { getDueFooterLogoUrl } from "@/utils/storageRefs.js";
import { doc, getDoc } from "firebase/firestore";
import { db } from "@/config/firebase";

export default {
  name: "FooterBar",
  data(){
    return { dueLogoUrl: "", appVersion: "", buildVersion: "", showReleaseNotes: false, releaseNotes: [] }
  },
  computed: {
    currentYear(){ return new Date().getFullYear(); }
  },
  mounted(){
    this.loadDueLogo();
    this.loadVersion();
    this.loadBuildVersion();
  },
  methods:{
    async loadDueLogo(){
      try {
        this.dueLogoUrl = await getDueFooterLogoUrl();
      } catch (_) {
        this.dueLogoUrl = '';
      }
    },
    async loadVersion(){
      try {
        const docRef = doc(db, "configuracoes", "versao");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data() || {};
          const version = data?.versaoAtualFrontend || "";
          const notes = data?.releaseNotes || data?.changelog || data?.resumoAtualizacoes || data?.releaseNotesFrontend || [];
          if (version) this.appVersion = version;
          if (Array.isArray(notes)) {
            this.releaseNotes = notes.map((item) => (item || '').toString()).filter((item) => item);
          } else if (typeof notes === 'string') {
            this.releaseNotes = notes
              .split('\n')
              .map((item) => item.trim())
              .filter((item) => item);
          }
        }
      } catch (error) {
        console.warn("Erro ao carregar versão do footer:", error);
      }
    },
    loadBuildVersion(){
      const buildVersion = process.env.VUE_APP_BUILD_VERSION || process.env.VUE_APP_VERSION || "";
      if (buildVersion) this.buildVersion = buildVersion;
    },
    openReleaseNotes(){
      this.showReleaseNotes = true;
    },
    closeReleaseNotes(){
      this.showReleaseNotes = false;
    }
  }
}
</script>

<style scoped>
.logoHome{ max-height: 32px; margin-right: 10px; }
.footerS{ display: flex; justify-content: center; align-items: center; background-color: var(--color-primary); padding: 10px 24px; color: var(--color-primary-contrast); }
.brand{ display:flex; align-items:center; gap:10px; text-decoration:none; color: var(--color-primary-contrast); }
.copy{ margin: 0; color: var(--color-primary-contrast); }
a{ text-decoration: none; }
.version-link{ background: none; border: none; padding: 0; color: inherit; font: inherit; cursor: pointer; text-decoration: none; }
.modal-overlay{ position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(10, 34, 43, 0.2); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.modal-content{ position: relative; background: var(--color-surface); padding: 20px; border-radius: 8px; width: 440px; max-width: 92%; text-align: left; color: var(--color-text); }
.modal-content h2{ margin: 0 0 8px; font-size: 18px; }
.modal-content ul{ margin: 8px 0 0 18px; padding: 0; }
.modal-content li{ margin-bottom: 6px; }
.build-text{ margin: 0 0 12px; color: var(--color-text-muted, #777); font-size: 13px; }
.empty-text{ margin: 0; color: var(--color-text-muted, #777); font-style: italic; }
.modal-close{ position: absolute; top: 10px; right: 10px; background: transparent; border: none; cursor: pointer; color: var(--color-text); }
.icon-button i{ font-size: 16px; }
</style>
